import request from '../../shared/request'

export function getDriverList() {
  return request('/drivers')
}



// WEBPACK FOOTER //
// ./src/redux/api/drivers.js